module.exports = "<div class=\"container-fluid\">\n\n  <div id=\"impressumContainer\" [innerHTML]=\"content\" class=\"container\">\n  </div>\n  \n</div>"